{
  "title": "Paiement des frais",
  "subTitle": "Sélectionnez un compte non enregistré pour y retirer des frais.",
  "currentAccount": "(compte courant)"
}
